export const LogoutIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M12 2V11.0909' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M17.4545 2.90918C20.1909 4.69327 22 7.58077 22 11.091C22 13.7432 20.9464 16.2867 19.0711 18.1621C17.1957 20.0374 14.6522 21.091 12 21.091C9.34784 21.091 6.8043 20.0374 4.92893 18.1621C3.05357 16.2867 2 13.7432 2 11.091C2 7.58077 3.80909 4.69327 6.54545 2.90918' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);

